import { render, staticRenderFns } from "./ApexColumn.vue?vue&type=template&id=58b6e842&scoped=true"
import script from "./ApexColumn.vue?vue&type=script&lang=js"
export * from "./ApexColumn.vue?vue&type=script&lang=js"
import style0 from "./ApexColumn.vue?vue&type=style&index=0&id=58b6e842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6e842",
  null
  
)

export default component.exports